export default (obj: object) => !Object.keys(obj).length;
